export default __webpack_public_path__ + "static/media/computerIcon.52edd6b4.svg";